/**
 * KoduAed rental checkout guard (KASSA_TOKE)
 *
 * Blocks checkout (standard submit + express buttons such as Apple Pay /
 * Google Pay / Shop Pay) whenever the cart contains a rental product that is
 * missing a non-empty Start/Finish rental period. Reads the per-line data
 * attributes rendered by main-cart-items.liquid, so it stays correct after
 * Dawn re-renders the cart via the Section Rendering API.
 *
 * Authoritative enforcement is the Shopify Cart/Checkout Validation Function;
 * this theme guard is the Basic-plan fallback and is client-side, therefore
 * bypassable by a determined user disabling JavaScript. It does NOT remove or
 * prune any cart line.
 */
(function () {
  'use strict';

  var LOCK_CLASS = 'koduaed-rental-lock';
  var DYNAMIC_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';
  var GUARD_SELECTOR = '[data-koduaed-rental-guard]';

  function isBlocked() {
    var lines = document.querySelectorAll('[data-koduaed-rental="true"]');
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-koduaed-has-period') !== 'true') {
        return true;
      }
    }
    return false;
  }

  function applyState(blocked) {
    var btn = document.getElementById('checkout');
    if (btn) {
      btn.classList.toggle(LOCK_CLASS, blocked);
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    }
    document.querySelectorAll(DYNAMIC_SELECTOR).forEach(function (el) {
      el.classList.toggle(LOCK_CLASS, blocked);
    });
    document.querySelectorAll(GUARD_SELECTOR).forEach(function (notice) {
      notice.hidden = !blocked;
    });
  }

  function onSubmit(e) {
    if (!isBlocked()) return;
    e.preventDefault();
    e.stopPropagation();
    var notice = document.querySelector(GUARD_SELECTOR);
    if (notice) {
      notice.hidden = false;
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  function bind() {
    var form = document.getElementById('cart');
    if (form && !form.dataset.koduaedRentalBound) {
      form.dataset.koduaedRentalBound = '1';
      form.addEventListener('submit', onSubmit, true);
    }
    applyState(isBlocked());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('cart:refresh', bind);

  // Re-evaluate whenever the cart line list is re-rendered (qty change / remove).
  var items = document.getElementById('main-cart-items');
  if (items) {
    new MutationObserver(bind).observe(items, { childList: true, subtree: true });
  }
})();
